import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  :not(:last-child) {
    margin-bottom: ${p => p.theme.space[3]}px;
  }

  gap: ${p => p.theme.space[3]}px;
  word-break: break-all;

  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${p => p.theme.colors.secondary.gray};
`;
